import type { ProjectCategory } from './common';
import type { ProjectSortPrefix, ProjectsSort } from './sorting';

/**
 * API Endpoints used for projects v2 queries.
 */
export const ENDPOINTS = {
  PROJECTS: '/api/v2/projects',
  RELEASE_GROUPS: '/api/v2/release-groups',
  CATEGORIES_SUMMARY: '/api/v2/projects/summary',
  ORGANIZATION_LABELS: '/api/organizations/labels',
  TEAMS: '/api/teams',
  BULK_LABEL: '/api/v2/projects/labels',
};

/**
 * is the passed in category "projects"
 */
export function isProjects(category: ProjectCategory): boolean {
  return category === 'projects';
}

/**
 * is the passed in category "releaseGroups"
 */
export function isReleaseGroups(category: ProjectCategory): boolean {
  return category === 'releaseGroups';
}

/**
 * is the passed in category "sharedProjects"
 */
export function isSharedProjects(category: ProjectCategory): boolean {
  return category === 'sharedProjects';
}

/**
 * does the passed in "sort" start with "category"
 */
export function isSortSelected(sort: ProjectsSort, category: ProjectSortPrefix) {
  return sort.startsWith(category);
}

/**
 * does the passed in "sort" end with "direction"
 */
export function isSortedByDirection(sort: ProjectsSort, direction: 'asc' | 'desc') {
  return sort.endsWith(direction);
}
